export enum PriceRecordSourceEnum {
  MOBILE = 'mobile',
  PC = 'pc',
}
